import { AxiosError } from 'axios';
import { CaptchaModel } from 'web-library';
import { useSelector } from 'react-redux';
import { POST_CAPTCHA_VERIFY_TOKEN_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { selectUsername } from '../../store/appSlice';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostCaptchaVerifyTokenResponse {
  siteKey: string;
  event: {
    token: string;
    siteKey: string;
  };
  score: number;
  isBot: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PostCaptchaVerifyTokenResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCaptchaVerifyToken = ({ onSuccess, onError }: Input = {}) => {
  const username = useSelector(selectUsername);
  const postCaptchaVerifyToken = async (captchaModel: CaptchaModel) => {
    const res = await axiosClient.post<PostCaptchaVerifyTokenResponse>(
      POST_CAPTCHA_VERIFY_TOKEN_URL,
      captchaModel,
      { params: { username, portalType: 'CP' } }
    );

    return res.data;
  };

  return useCustomMutation(postCaptchaVerifyToken, {
    onSuccess,
    onError,
  });
};
